<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Minimum Customer Letter Tariff</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_Tariff()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>
          <button *ngIf="!Procssing"  (click)="openModal_Tariff(templateTariff)" type="button" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
          <button routerLink="/Tariff" *ngIf="!Procssing" type="button" class="btn btn-warning"><i
              class="fa fa-mail-reply"></i> Back </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Amount (IRR)</th>
              <th>Date</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Tariff
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_Tariff.length
                      }">
              <td>{{DataList_Tariff.indexOf(item)+1}}</td>
              <td>{{item.price|number}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #templateTariff>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Add Amount (IRR) </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Tariff.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> New Amount (IRR) </label>
        <input [(ngModel)]="txt_Price"   (keyup)="khadamat_Change()"  type="number" class="form-control"
        placeholder="Type here...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> New Amount in Words </label>
        <input [(ngModel)]="txt_PriceAlph"  disabled type="text" class="form-control">
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
      (click)="submitTarrif()"> Save Amount <i class="fa fa-plus-circle"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Tariff.hide()">Close <i class="fa fa-remove"></i></button>
  </div>
</ng-template>